export function commonFunc() {
  $(".topicon ul").each(function (index, element) {
    if ($(this).find("li").length == 0) {
      $(this).append(
        '<p class="not">開催中・開催予定のセミナーはございません。</p>'
      );
    }
  });

  //リンクからハッシュを取得
  var hash = location.hash;
  hash = (hash.match(/^#tab\d+$/) || [])[0];
  console.log(hash);
  //リンクにハッシュが入っていればtabnameに格納
  if ($(hash).length) {
    var tabname = hash.slice(1);
  } else {
    var tabname = "tab1";
  }

  //コンテンツ非表示&amp;タブを非アクティブ
  $(".topicon > div").css("display", "none");
  var tabno = $(".topicon > div#" + tabname).index();
  console.log(tabno);
  //タブのアクティブ化
  $(".tab li").removeClass("select");
  $(".tab li#" + tabname).addClass("select");
  $(".tab li").eq(tabno).addClass("select");
  $(".topicon > div").eq(tabno).fadeIn("slow");

  $("dl.trigger").hover(
    function () {
      // マウスが dt に乗った時に dd をフェードイン
      $(this).find("dd").stop().fadeIn(300);
    },
    function () {
      // マウスが dt から外れた時に dd をフェードアウト
      $(this).find("dd").stop().fadeOut(300);
    }
  );
}
